module.exports = __webpack_public_path__ + "storage-icon.png?fa1301fb369f47a745fbabdc1f9ee085";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/storage-icon.png
// module id = 56
// module chunks = 0